import { createStore } from '@stencil/store';
import { BusinessDistance, FinanceOption, LoanDistance, PrivateDistance } from '../types';

type StateType = {
  activeFinanceOption: FinanceOption;
  businessDistance: BusinessDistance;
  privateDistance: PrivateDistance;
  loanDistance: LoanDistance;
  activeType: number;
};

const {
  state,
}: {
  state: StateType;
} = createStore({
  activeFinanceOption: FinanceOption.All,
  businessDistance: BusinessDistance.One,
  privateDistance: PrivateDistance.One,
  loanDistance: LoanDistance.One,
  activeType: 9999,
});

export default state;
